export default __webpack_public_path__ + "static/media/793.6aa80408.png";